<app-dynamic-form title="Underwriter Agent" [input]="data!" (result)="doHandleResult($event)"></app-dynamic-form>
